import { Observable } from 'rxjs';
import {
  ApiService,
  GET_NEARBY_GAMES_ALERTS_PATH,
  GetNearbyGamesAlertsResponse,
  UPDATE_NEARBY_GAMES_ALERTS_ENABLED_PATH,
  UPDATE_NEARBY_GAMES_ALERTS_LOCATION_PATH,
  UPDATE_NEARBY_GAMES_ALERTS_PATH,
  UPDATE_PUSH_NOTIFICATION_ENABLED_PATH,
  UpdateNearbyGamesAlertsBody,
  UpdateNearbyGamesAlertsEnabledBody,
  UpdateNearbyGamesAlertsLocationBody,
  UpdatePushNotificationEnabledBody
} from '@core-http';
import { CoordinatesModel } from '@core';

export class NotificationsAlertsService extends ApiService {
  getAlerts(): Observable<GetNearbyGamesAlertsResponse> {
    return this.httpClient.get<GetNearbyGamesAlertsResponse>(`${this.env.apiUrl}${GET_NEARBY_GAMES_ALERTS_PATH}`);
  }

  updateAlerts(settings: UpdateNearbyGamesAlertsBody): Observable<void> {
    return this.httpClient.put<void>(`${this.env.apiUrl}${UPDATE_NEARBY_GAMES_ALERTS_PATH}`, settings);
  }

  switchAlerts(value: boolean): Observable<void> {
    const payload: UpdateNearbyGamesAlertsEnabledBody = { isEnabled: value };

    return this.httpClient.patch<void>(`${this.env.apiUrl}${UPDATE_NEARBY_GAMES_ALERTS_ENABLED_PATH}`, payload);
  }

  setLocation(coordinates: CoordinatesModel | null): Observable<void> {
    const payload: UpdateNearbyGamesAlertsLocationBody = { coordinates: coordinates };

    return this.httpClient.patch<void>(`${this.env.apiUrl}${UPDATE_NEARBY_GAMES_ALERTS_LOCATION_PATH}`, payload);
  }

  setPushStatus(value: boolean): Observable<void> {
    const payload: UpdatePushNotificationEnabledBody = { value: value };

    return this.httpClient.put<void>(`${this.env.apiUrl}${UPDATE_PUSH_NOTIFICATION_ENABLED_PATH}`, payload);
  }
}
